import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import http from "../helper/http-client";
import {
  fetchSeasonsStart,
  fetchSeasonsFailure,
  fetchSeasonsSuccess,
} from "../app/seasonSlice";
import { fetchGlobalCoins, fetchPrice } from "../app/priceSlice";

let inFlightSeasonsPromise = null;
let lastFetchedAt = 0;

const useSeason = () => {
  const dispatch = useDispatch();
  const season = useSelector((state) => state.season);
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    // Verhindert 4× parallele Calls aus HeaderTop, Sidebar, HomeTopSection, TopPlaces
    if (season?.seasons?.length > 0 && Date.now() - lastFetchedAt < 60000) {
      return;
    }
    if (inFlightSeasonsPromise) {
      return;
    }

    const fetchAllSeasons = async () => {
      dispatch(fetchSeasonsStart());
      try {
        inFlightSeasonsPromise = http.get("/season/get-all");
        const res = await inFlightSeasonsPromise;
        lastFetchedAt = Date.now();

        const rawSeasons = Array.isArray(res.data) ? res.data : [];
        const needsFallback = rawSeasons.some(
          (item) =>
            Array.isArray(item.topMembers) &&
            item.topMembers.length > 0 &&
            typeof item.topMembers[0] === "string" &&
            !Array.isArray(item.topMembersData)
        );

        let fallbackResults = null;
        if (needsFallback) {
          const resResult = await http.get("/result/pyramid-board");
          fallbackResults = Array.isArray(resResult.data) ? resResult.data : [];
        }

        const seasonData = rawSeasons.map((item) => {
          if (Array.isArray(item.topMembersData)) {
            return { ...item, topMembers: item.topMembersData };
          }
          if (fallbackResults) {
            const ids = (item.topMembers || []).map((id) => String(id));
            const topMembers = fallbackResults.filter((val) =>
              ids.includes(String(val._id))
            );
            return { ...item, topMembers };
          }
          return item;
        });

        dispatch(fetchSeasonsSuccess(seasonData));
        if (user?._id) {
          dispatch(fetchPrice({ userId: user._id }));
        }
        dispatch(fetchGlobalCoins());
      } catch (err) {
        dispatch(fetchSeasonsFailure(err));
      } finally {
        inFlightSeasonsPromise = null;
      }
    };

    fetchAllSeasons();
  }, [dispatch, season?.seasons?.length, user?._id]);

  return { season };
};

export default useSeason;
